/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewloading2Inputs */

const en_letterpreviewloading2 = /** @type {(inputs: Letterpreviewloading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafting your letter…`)
};

const pt_letterpreviewloading2 = /** @type {(inputs: Letterpreviewloading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A preparar a sua carta…`)
};

/**
* | output |
* | --- |
* | "Drafting your letter…" |
*
* @param {Letterpreviewloading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewloading2 = /** @type {((inputs?: Letterpreviewloading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewloading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewloading2(inputs)
	return pt_letterpreviewloading2(inputs)
});
export { letterpreviewloading2 as "letterPreviewLoading" }